/**
 * A dragged thing's picture for `DragStack`: drawn at once, because the browser takes its picture
 * of the stack as the drag starts. It skips the loader a tile uses, which would show nothing yet.
 */
export function DragPicture({ src }: { src: string }) {
  return (
    <img
      src={src}
      alt=""
      loading="eager"
      decoding="sync"
      className="size-full object-cover"
    />
  );
}
